"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LikeIcon = function LikeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.595 9.45514L18.7223 8.89586C18.7223 8.18036 18.1477 7.59536 17.445 7.59536L10.9663 7.59536L12.1417 3.12107V3.09536C12.257 2.66593 12.155 2.18507 11.8097 1.84693L6.69899 7.06243C6.22566 7.53043 5.94499 8.181 5.94499 8.89586L5.94499 14.0985C5.94499 15.5289 7.09499 16.6995 8.50033 16.6995H13.6117C14.6337 16.6995 15.5283 16.0881 15.9243 15.2171H15.911L18.595 9.45514ZM13.6117 18H8.50033C6.37899 18 4.66699 16.2572 4.66699 14.0979L4.66699 8.89586C4.66699 7.8165 5.10166 6.84129 5.79166 6.13864L11.8097 0L12.717 0.923143C13.3943 1.61293 13.6117 2.601 13.3683 3.48557L12.6277 6.29486L17.445 6.29486C18.8503 6.29486 20.0003 7.46486 20.0003 8.89586C20.0003 9.33814 19.8983 9.75407 19.707 10.1186L17.1383 15.6201C16.563 17.0113 15.1957 18 13.6117 18Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.42856L6 16.7143C6 17.6657 5.55533 18 4.66667 18H2.00133C1 18 0 17.3153 0 16.0714L0 8.45806C0 7.44427 0.502667 6.42856 1.99667 6.42856L6 6.42856ZM4.66667 7.64677L1.99667 7.64677C1.33333 7.64677 1.33333 8.05756 1.33333 8.46834L1.33333 16.1312C1.33333 16.5683 1.66533 16.7818 1.99667 16.7818H4.66667L4.66667 7.64677Z",
    fill: color
  }));
};

var _default = LikeIcon;
exports.default = _default;